"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonacoEditor = void 0;
var monaco = __importStar(require("monaco-editor"));
var react_1 = __importStar(require("react"));
var MonacoEditor = function (_a) {
    var options = _a.options, className = _a.className, configure = _a.configure;
    var _b = __read((0, react_1.useState)(null), 2), div = _b[0], setDiv = _b[1];
    var divCallback = (0, react_1.useCallback)(function (node) {
        setDiv(node);
    }, []);
    (0, react_1.useLayoutEffect)(function () {
        var editor;
        if (div) {
            var domElement = document.createElement('div');
            domElement.classList.add(className);
            div.appendChild(domElement);
            editor = monaco.editor.create(domElement, options);
            configure(editor);
        }
        return function () {
            editor === null || editor === void 0 ? void 0 : editor.dispose();
            (div === null || div === void 0 ? void 0 : div.firstElementChild) && (div === null || div === void 0 ? void 0 : div.removeChild(div.firstElementChild));
        };
    }, [className, configure, div, divCallback, options]);
    return react_1.default.createElement("div", { ref: divCallback });
};
exports.MonacoEditor = MonacoEditor;
//# sourceMappingURL=MonacoEditor.js.map